export const TEXTO_ESTATICO_LOAD = "TEXTO_ESTATICO_LOAD";
